export const environment = {
  production: false,
  apiUrl: '/api',
  address: 'http://localhost:6051'
  //address: 'https://2mhr.dux8.com'

}; 